import React from 'react';
import { Avatar, Stack, SvgIcon, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useQuery } from 'react-query';
import API, { Types, useAuth } from '@wheeebo/polaris-api';
import { AsvIcon, DroneIcon, HoverbikeIcon } from '@wheeebo/polaris-svg';
import { SquareChip } from '../chip';
import { CircleLoader, LoadError } from '../loader';
const ACTIVE_VEHICLE_TIME_THRESHOLD = 10000; // 10 seconds
function VehiclePanel({ vehicle, vehicleId, showVehicleType, showActive, showMissionInProgress, showFlightStatus, ...props }) {
    const { account } = useAuth();
    const theme = useTheme();
    const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const options = { preload: ['owner'] };
    if (showMissionInProgress) {
        options.preload?.push('active_flight_plan');
    }
    if (showFlightStatus) {
        options.preload?.push('last_flight_log');
    }
    const { data, isLoading, isError } = useQuery(vehicleId ? API.Vehicles.getKey(vehicleId, options) : '', () => (vehicleId ? API.Vehicles.get(vehicleId, options) : undefined), { enabled: !vehicle && !!vehicleId });
    const content = vehicle || data;
    const active = Date.now() - (content?.lastHeartbeatAt || 0) < ACTIVE_VEHICLE_TIME_THRESHOLD;
    const lastFlightLog = content?.activeFlightPlan?.lastFlightLog;
    if (vehicle) {
        if (isLoading) {
            return React.createElement(CircleLoader, null);
        }
        else if (isError) {
            return React.createElement(LoadError, null);
        }
    }
    return (React.createElement(Stack, { gap: 1, direction: "row", sx: { alignItems: 'center', cursor: 'pointer' }, ...props },
        React.createElement(Avatar, { variant: "rounded", src: content?.imageUrl, sx: { width: 32, height: 32, backgroundColor: 'transparent' } },
            React.createElement(SvgIcon, { color: "disabled" }, content?.vehicleType === Types.VehicleTypeHoverbike ? (React.createElement(HoverbikeIcon, null)) : content?.vehicleType === Types.VehicleTypeAsv ? (React.createElement(AsvIcon, null)) : (React.createElement(DroneIcon, null)))),
        React.createElement(Typography, { variant: "caption" }, content?.name || content?.id),
        isBigScreen && content?.owner?.id === account?.id ? React.createElement(SquareChip, { label: "Yours", color: "primary" }) : null,
        showVehicleType ? React.createElement(SquareChip, { label: content?.vehicleType }) : null,
        showActive && active ? React.createElement(SquareChip, { label: "Active", color: "success" }) : null,
        showMissionInProgress && content?.activeFlightPlan ? (React.createElement(SquareChip, { label: "Mission in Progress", color: "error" })) : null,
        showFlightStatus ? (lastFlightLog?.status === Types.FlightLogStatusExecuting ? (React.createElement(SquareChip, { label: "Executing", color: "error" })) : lastFlightLog?.status === Types.FlightLogStatusPaused ? (React.createElement(SquareChip, { label: "Paused", color: "info" })) : lastFlightLog?.status === Types.FlightLogStatusCompleted ? (React.createElement(SquareChip, { label: "Completed", color: "success" })) : lastFlightLog?.status === Types.FlightLogStatusIncompleted ? (React.createElement(SquareChip, { label: "Incompleted", color: "warning" })) : null) : null));
}
export default React.memo(VehiclePanel);
